var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[_vm._v(" "+_vm._s(_vm.firstCategory)+" "),(_vm.countRestOfCategory)?_c('span',{staticClass:"font-semibold"},[_vm._v(" "+_vm._s(_vm.countRestOfCategory)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }